import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';


import Program from './Content/Program';
import Mediathek from './Content/Mediathek';
import Agenda from './Content/Agenda';
import AccountChangePassword from './Content/AccountChangePassword';
import AccountDelete from './Content/AccountDelete';
import AccountLogin from './Content/AccountLogin';
import AccountLogout from './Content/AccountLogout';
import AccountProfile from './Content/AccountProfile';
import AccountRegister from './Content/AccountRegister';
import AccountRegisterWelcome from './Content/AccountRegisterWelcome';
import AccountResetPassword from './Content/AccountResetPassword';
import AccountStatus from './Content/AccountStatus';
import AccountVerifyEmail from './Content/AccountVerifyEmail';
import AccountWelcome from './Content/AccountWelcome';


const Content = () => {

  return (

        <Routes>
          <Route
            path="/404"
            element={ () => {
              window.location = 'https://www.arte.tv/errors/static/404.html';
              return null;
            } }
          />
          <Route
            path="/"
            element={ () => {
              window.location = '/';
              return null;
            } }
          />
          <Route path="/programm/:date/:programId" element={<Program />}/>
          <Route path="/mediathek/:programId" element={<Mediathek />}/>
          <Route path="/web-only-kalender/" element={<Agenda />}/>
          <Route path="/account/" element={<AccountStatus />}/>
          <Route path="/account-change-password/" element={<AccountChangePassword />}/>
          <Route path="/account-delete/" element={<AccountDelete />}/>
          <Route path="/account-login/" element={<AccountLogin />}/>
          <Route path="/account-logout/" element={<AccountLogout />}/>
          <Route path="/account-profile/" element={<AccountProfile />}/>
          <Route path="/account-register/" element={<AccountRegister />}/>
          <Route path="/account-register-welcome/" element={<AccountRegisterWelcome />}/>
          <Route path="/account-reset-password/" element={<AccountResetPassword />}/>
          <Route path="/account-verify-email/" element={<AccountVerifyEmail />}/>
          <Route path="/account-welcome/" element={<AccountWelcome />}/>

          <Route
            path="/"
            element={ () => {
              // Ensure we don't try to load pages we can't.
              // Don't reload directly, we don't want to keep page state (i.e. scroll position).
              window.location = window.location.href;
              return null;
            } }
          />
        </Routes>
  );
};

export default Content;
